import { render, staticRenderFns } from "./Currencies.vue?vue&type=template&id=3c12053a&scoped=true&"
import script from "./Currencies.vue?vue&type=script&lang=js&"
export * from "./Currencies.vue?vue&type=script&lang=js&"
import style0 from "./Currencies.vue?vue&type=style&index=0&id=3c12053a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c12053a",
  null
  
)

export default component.exports